// extracted by mini-css-extract-plugin
export default {"icons":"ohIqfAeSzWDUpZZi8XdYRQ=="};